import React from "react";
import { Send, Bell, Trash2, Sparkles, ExternalLink, Copy, Check, Radar, FileDown } from "lucide-react";

// Shared action cluster for an invoice. `compact` renders the 36px desktop
// buttons; otherwise 44px touch-friendly targets for the mobile card list.
export const InvoiceRowActions = ({ inv, actions, compact = false }) => {
  const btn = `${compact ? "p-2" : "p-3"} rounded-md transition-colors`;
  const base = `${btn} hover:bg-[#241c17] text-zinc-400 hover:text-white`;
  const size = compact ? 14 : 16;
  return (
    <div className={`flex items-center justify-end flex-wrap ${compact ? "gap-1" : "gap-0.5"}`}>
      {inv.status === "draft" && (
        <button onClick={() => actions.send(inv.invoice_id)} data-testid={`send-invoice-${inv.number}`} title="Send" aria-label="Send invoice" className={base}>
          <Send size={size} strokeWidth={1.5} />
        </button>
      )}
      {(inv.status === "sent" || inv.status === "overdue") && (
        <button onClick={() => actions.remind(inv.invoice_id)} data-testid={`remind-${inv.number}`} title="Remind" aria-label="Send reminder" className={base}>
          <Bell size={size} strokeWidth={1.5} />
        </button>
      )}
      {inv.status === "pending_confirmation" && (
        <>
          <button onClick={() => actions.verifyOnchain(inv.invoice_id, inv.number)} data-testid={`verify-onchain-${inv.number}`} title="Verify on-chain now" aria-label="Verify on-chain" className={`${btn} hover:bg-sky-500/10 text-sky-400 hover:text-sky-300`}>
            <Radar size={size} strokeWidth={1.75} />
          </button>
          <button onClick={() => actions.confirm(inv)} data-testid={`confirm-payment-${inv.number}`} title="Manually confirm payment received" aria-label="Confirm payment" className={`${btn} hover:bg-emerald-500/10 text-emerald-400 hover:text-emerald-300`}>
            <Check size={size} strokeWidth={2} />
          </button>
        </>
      )}
      <button onClick={() => actions.ai(inv.invoice_id, inv.number)} data-testid={`ai-followup-${inv.number}`} title="AI draft" aria-label="AI follow-up draft" className={base}>
        <Sparkles size={size} strokeWidth={1.5} />
      </button>
      <button onClick={() => actions.copyLink(inv.invoice_id)} data-testid={`copy-link-${inv.number}`} title="Copy link" aria-label="Copy payment link" className={base}>
        <Copy size={size} strokeWidth={1.5} />
      </button>
      <button onClick={() => actions.downloadPdf(inv.invoice_id, inv.number)} data-testid={`download-pdf-${inv.number}`} title="Download PDF" aria-label="Download PDF" className={base}>
        <FileDown size={size} strokeWidth={1.5} />
      </button>
      <a href={`/pay/${inv.invoice_id}`} target="_blank" rel="noreferrer" data-testid={`open-${inv.number}`} title="Open" aria-label="Open public invoice" className={base}>
        <ExternalLink size={size} strokeWidth={1.5} />
      </a>
      <button onClick={() => actions.del(inv.invoice_id)} data-testid={`delete-${inv.number}`} title="Delete" aria-label="Delete invoice" className={`${btn} hover:bg-[#241c17] text-zinc-400 hover:text-rose-400`}>
        <Trash2 size={size} strokeWidth={1.5} />
      </button>
    </div>
  );
};
